/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Origin_RemixInputs */

const en_road_dude_origin_remix = /** @type {(inputs: Road_Dude_Origin_RemixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI remakes keep the window-level shot and the deadpan timing while changing the driver or the setting. A cat defending a fishing pond lands the joke because it plays the part with the same seriousness.`)
};

const zh_road_dude_origin_remix = /** @type {(inputs: Road_Dude_Origin_RemixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 翻拍保留了车窗视角和一本正经的停顿，把司机或场景换掉。猫咪板着脸守池塘，反差就是笑点。`)
};

/**
* | output |
* | --- |
* | "AI remakes keep the window-level shot and the deadpan timing while changing the driver or the setting. A cat defending a fishing pond lands the joke because ..." |
*
* @param {Road_Dude_Origin_RemixInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_origin_remix = /** @type {((inputs?: Road_Dude_Origin_RemixInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Origin_RemixInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_origin_remix(inputs)
	return zh_road_dude_origin_remix(inputs)
});
export { road_dude_origin_remix as "road_dude.origin.remix" }